<h2 mat-dialog-title>Arrange Promise</h2>

<form [formGroup]="form" (ngSubmit)="onConfirm()" autocomplete="off">
	<mat-dialog-content>
		<dl class="context">
			<dt>Loan Number</dt>
			<dd>{{ data.promise.loanNumber }}</dd>
			<dt>Amount</dt>
			<dd>{{ FormatUtil.formatCurrency(data.promise.amount) }}</dd>
			<dt>Promise Date</dt>
			<dd>{{ data.promise.promiseDate }}</dd>
		</dl>

		<formly-form
			[form]="form"
			[fields]="fields"
			[model]="model"
		></formly-form>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()">
			Cancel
		</button>
		<button mat-raised-button color="primary" type="submit">
			Arrange
		</button>
	</mat-dialog-actions>
</form>
